<template>
  <div class="mb-3">
    <Alert
      type="alert-info"
      text="Commands are a quick way to start chat with the bot.
      In this section you have to link which chat should be invoked on sending the specified command.
      It is necessery to create 'start' command for every bot. User starts the bot for first time by sending '/start'
      command. dont use '/' in the command name."
    ></Alert>
    <AlertLink link="/user-guide#Commands" text="Read more about commands here"></AlertLink>
    <div
      class="mb-3"
      v-for="(cmd, index) in commands"
      :key="index"
      :class="[cmd.error ? 'error' : '']"
    >
      <div class="input-group">
        <div
          class="input-group-prepend"
          title="Use lowercase letters, numbers and underscores only"
        >
          <span class="input-group-text">/</span>
        </div>
        <input
          type="text"
          class="form-control"
          v-model.trim="cmd.command"
          placeholder="command"
          maxlength="32"
          pattern="[a-z0-9_]+"
          title="Use lowercase letters, numbers and underscores only"
        />
        <select class="form-control" v-model="cmd.chat">
          <option value="null">Select Chat</option>
          <option
            v-for="(chat_name, index) in chat_names"
            :value="chat_name"
            :key="index"
          >{{chat_name}}</option>
        </select>
        <div class="input-group-append">
          <button @click="removeCommand(index)" class="btn btn-outline-danger btn-sm">X</button>
        </div>
      </div>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="cmd.description"
          placeholder="what this command does?"
          maxlength="256"
        />
        <div class="input-group-append">
          <span class="input-group-text">
            <input type="checkbox" class="form-check-input" v-model="cmd.admin" />Admin only
          </span>
        </div>
        <div class="input-group-append">
          <span class="input-group-text">
            <input type="checkbox" class="form-check-input" v-model="cmd.prime" />Prime only
          </span>
        </div>
      </div>
    </div>
    <button @click="addCommand" class="btn btn-outline-info btn-block">Add Command</button>
  </div>
</template>


<style>
.error {
  border-style: solid;
  border-color: red;
}
</style>


<script>
import Alert from "@/components/Alert.vue";
import AlertLink from "@/components/AlertLink.vue";



export default {
  name: "Commands",
  components:{
    Alert,
    AlertLink
  },
  props: {
    commands: Array,
    chat_names: Array
  },
  methods: {
    removeCommand: function(index) {
      this.$emit("removeCommand", index);
    },
    addCommand: function() {
      this.$emit("addCommand", this.commands);
    }
  }
};
</script>
